/**
 * Route: /admin/users — platform-admin user management.
 *
 * `beforeLoad` checks the current user's platform_role; non-admin visitors
 * are bounced back to `/` with a Dutch toast explaining the restriction.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { me } from '../../lib/auth';
import { toast } from '../../lib/toast';
import { UsersAdmin } from '../../features/admin/UsersAdmin';

export const Route = createFileRoute('/admin/users')({
  beforeLoad: async () => {
    try {
      const profile = await me();
      if (profile.platform_role !== 'admin') {
        toast({
          tone: 'error',
          message: 'Alleen admins hebben toegang tot deze pagina.',
        });
        throw redirect({ to: '/' });
      }
    } catch (err) {
      // `redirect()` throws a router signal that must propagate; only catch real errors.
      if (err && typeof err === 'object' && 'to' in err) {
        throw err;
      }
      throw redirect({ to: '/login' });
    }
  },
  component: UsersAdmin,
});
